import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { WalletService } from '../../../Service/wallet/wallet.service';
import { RechargePopupService } from '../../../Service/wallet/recharge-popup.service';

@Injectable()
export class WalletInterceptor implements HttpInterceptor {
  private balanceChecked = false;

  constructor(
    private walletService: WalletService,
    private popupService: RechargePopupService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if this request might affect the wallet balance
    const isModifyingRequest = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(request.method);

    return next.handle(request).pipe(
      tap(event => {
        if (event instanceof HttpResponse && isModifyingRequest) {
          // Only check balance after requests that might modify it
          this.checkWalletBalance();
        }
      })
    );
  }

  private checkWalletBalance(): void {
    // Avoid multiple simultaneous checks
    if (this.balanceChecked) return;

    this.balanceChecked = true;
    this.walletService.getWalletBalance().subscribe({
      next: (res) => {
        this.popupService.setShowPopup(res.availableBalance <= 0);
      },
      complete: () => {
        this.balanceChecked = false;
      }
    });
  }
}